import { useTranslation } from "react-i18next";

import { ACT_OPENING, type ActId } from "@/components/projects/diagnostic/acts";

/**
 * O H2 e o parágrafo de abertura de cada ato (#852).
 *
 * Não é decoração: é o que o vendedor fala antes de mostrar o primeiro número, e
 * é o que transforma cinco telas em uma conversa com ordem.
 */
export function ActOpening({ act }: { act: ActId }) {
  const { t } = useTranslation();
  const { heading, intro } = ACT_OPENING[act];

  return (
    <header className="mb-6 flex flex-col gap-2">
      <h2 className="font-brand text-[24px] font-extrabold leading-[1.15] tracking-[-0.02em] text-[#08254c]">
        {t(heading)}
      </h2>
      <p className="max-w-[72ch] text-[14px] leading-relaxed text-[#596b85]">
        {t(intro)}
      </p>
    </header>
  );
}
